export default __webpack_public_path__ + "static/media/logo.62797ed2.png";